export default {
  border: {
    left: require("assets/images/road/border-left.svg").default,
    right: require("assets/images/road/border-right.svg").default,
  },
  single: {
    default: require("assets/images/road/single.svg").default,
    selected: require("assets/images/road/single-selected.svg").default,
    borderLeft: require("assets/images/road/single-border-left.svg").default,
    borderRight: require("assets/images/road/single-border-right.svg").default,
    borderBoth: require("assets/images/road/single-border-both.svg").default,
  },
  double: {
    default: require("assets/images/road/double.svg").default,
    selected: require("assets/images/road/double-selected.svg").default,
    borderLeft: require("assets/images/road/double-border-left.svg").default,
    borderRight: require("assets/images/road/double-border-right.svg").default,
    borderBoth: require("assets/images/road/double-border-both.svg").default,
  },
};